module.exports = __webpack_public_path__ + "img/icon-carpenter.74796636.png";